export const HISTORY_COLUMNS = [
  { key: 'id', label: 'Job ID', width: 130 },
  { key: 'dateFrom', label: 'Start date', width: 125 },
  { key: 'dateTo', label: 'End date', width: 125 },
  { key: 'source', label: 'Source', width: 115 },
  { key: 'tableId', label: 'Destination table', width: 185 },
  { key: 'status', label: 'Status', width: 130 },
  { key: 'error', label: 'Reason', width: 280 },
  { key: 'startedAt', label: 'Execution start (UTC)', width: 190 },
  { key: 'completedAt', label: 'Execution end (UTC)', width: 190 },
  { key: 'triggeredBy', label: 'User', width: 170 },
  { key: 'rows', label: 'Rows delivered', width: 150 },
];

export function historyTimestamp(value) {
  if (!value) return '';
  const date = new Date(value);
  return Number.isFinite(date.getTime()) ? date.toISOString().slice(0, 19).replace('T', ' ') : '';
}

export function historyValue(job, key) {
  if (key === 'startedAt' || key === 'completedAt') return historyTimestamp(job[key]);
  if (key === 'rows') return job.status === 'Successful' ? Number(job.rows) || 0 : 0;
  return String(job[key] ?? '');
}

export function historyCsv(jobs) {
  const cell = value => {
    let text = String(value ?? '');
    if (/^[\s]*[=+@-]/.test(text)) text = "'" + text;
    return `"${text.replaceAll('"', '""')}"`;
  };
  return [HISTORY_COLUMNS.map(column => cell(column.label)).join(','),
    ...jobs.map(job => HISTORY_COLUMNS.map(column => cell(historyValue(job, column.key))).join(','))].join('\r\n');
}

export function historyPath(exportId) {
  return `/reach-tool/analyze-act/exports/${encodeURIComponent(exportId)}/history`;
}

export function historyExportId(path) {
  const match = /^\/reach-tool\/analyze-act\/exports\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/history\/?$/i.exec(path);
  return match?.[1] || null;
}
